<template>
  <div>
    <CheckoutsList
      :checkouts="checkouts"
      :readonly="readonly"
      :hide-warnings="hideWarnings"
      :has-active-products="hasActiveProducts"
      :compact="compact"
      @refresh="$emit('refresh')"
    >
      <template #actions="{ onOpenCheckout }">
        <slot name="actions" :on-open-checkout="onOpenCheckout" />
      </template>
    </CheckoutsList>
    <template v-if="checkout">
      <CheckoutTotal
        :checkout="checkout"
        :has-active-products="hasActiveProducts"
      />
      <hr />
      <CheckoutTotalOperations
        :checkout="checkout"
        :has-active-products="hasActiveProducts"
      />
      <hr />
      <CheckoutCashFlowCardGroup
        :checkout="checkout"
        :readonly="readonly"
        :is-admin="isAdmin"
        @refresh="$emit('refresh')"
      />
      <CheckoutRentsCardGroup
        :checkout="checkout"
        :has-active-products="hasActiveProducts"
      />
    </template>
  </div>
</template>

<script>
import CheckoutsList from '@/components/Checkouts/CheckoutsList'
import CheckoutTotal from '@/components/Checkouts/CheckoutTotal'
import CheckoutCashFlowCardGroup from './CheckoutCashFlowCardGroup'
import CheckoutRentsCardGroup from './CheckoutRentsCardGroup'
import CheckoutTotalOperations from './CheckoutTotalOperations'
import { mapGetters } from 'vuex'

export default {
  name: 'CheckoutDetails',
  components: {
    CheckoutsList,
    CheckoutTotal,
    CheckoutCashFlowCardGroup,
    CheckoutRentsCardGroup,
    CheckoutTotalOperations
  },
  props: {
    checkouts: {
      type: Object,
      required: true
    },
    checkout: {
      type: Object,
      default: null
    },
    hasActiveProducts: {
      type: Boolean,
      default: true
    },
    compact: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean
    },
    hideWarnings: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters('store', ['currentStoreId', 'isAdmin'])
  }
}
</script>
